import Axios from 'axios'
import {useState} from 'react'
import './App.css';

function App() {
    const [swNum, setSwNum] = useState("");
    const [swName, setSwName] = useState("");
    const [swChosen, setSwChosen] = useState(false)
  const [sw, setSw] = useState({
            
  })
  
  
    const searchSw= () => {
      Axios.get(`https://swapi.py4e.com/api/${swName}/${swNum}`).then(
        (response) =>{
          if (response.data.name){
          setSw({ 
            name: response.data.name, 
            gravity: response.data.gravity,
            hair: response.data.hair_color,
            mass: response.data.mass,
            height: response.data.height,
            skin: response.data.skin_color,
            eye: response.data.eye_color,
            birth: response.data.birth_year,
            gender: response.data.gender,
            rotation: response.data.rotation_period,
            orbital: response.data.orbital_period,
            diameter: response.data.diameter,
            climate: response.data.climate,
            terrain: response.data.terrain,
            population: response.data.population
          });
          setSwChosen(true)
        }
        })    
    }
  
   
    return (
      <div><div className="App"></div><div class="parent"><div class="child"><p className="selectdiv">
        <select className="select" onChange={(e) =>{
          const selectedName=e.target.value
          setSwName(selectedName)
        }}>
  <option  disabled selected>wybierz typ danych:</option>
  <option value="planets">planets</option>
  <option value="people">people</option>
</select>
</p>
</div>
<div class="child">
<p className="selectdiv">
        <select className="select" onChange={(e) =>{
          const selectedNum=e.target.value
          setSwNum(selectedNum)
        }}>
  <option  disabled selected>wybierz ID:</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
</select>
</p>
</div>
<div class="child">
        <button className="btn41-43 btn-41" onClick={searchSw}>search</button>
        </div>
        </div>
       <div className="swf">{!swChosen ? ( <h1></h1>
       ) : (
         <>{!sw.gravity ? (<div className="sw">
         <h1 className="swf">name: {sw.name}</h1>
         <h2 className="swf">height: {sw.height}</h2>
         <h2>mass: {sw.mass}</h2>
         <h2>hair color: {sw.hair}</h2>
         <h2>eye color: {sw.eye}</h2>
         <h2>birth year: {sw.birth}</h2>
         <h2>gender: {sw.gender}</h2>
         </div>):(<><div className="sw">
          <h1 className="swf">name: {sw.name}</h1>
          <h2 className="swf">rotation period: {sw.rotation}</h2>
          <h2 className="swf">orbital period: {sw.orbital}</h2>
          <h2>diameter: {sw.diameter}</h2>
          <h2>climate: {sw.climate}</h2>
          <h2>gravity: {sw.gravity}</h2>
          <h2>population: {sw.population}</h2>
          </div>
         </>)}
         </>
       )}
       
       </div>
      </div>
    );
    }
  
  
  
export default App;
